import {
  Directive,
  Input,
  inject,
  HostListener,
  OnInit,
} from '@angular/core';
import { AmplitudeService } from './amplitude.service';

@Directive({
  selector: '[logAmplitudeEvent]',
  standalone: true,
})
export class LogAmplitudeEventDirective implements OnInit {
  private readonly _amplitude = inject(AmplitudeService);

  @Input() logAmplitudeEvent!: string;              // event name to log
  @Input() logAmplitudeProps?: Record<string, any>;    // optional event props
  @Input() logAmplitudeTrigger?: string;               // optional trigger

  ngOnInit(): void {
    if (!this.logAmplitudeTrigger && this.logAmplitudeEvent) {
      // Fire immediately if no trigger was provided
      this._log();
    }
  }

  @HostListener('click')
  onClick() {
    if (this.logAmplitudeTrigger === 'click') {
      this._log();
    }
  }

  @HostListener('mouseover')
  onHover() {
    if (this.logAmplitudeTrigger === 'mouseover') {
      this._log();
    }
  }

  @HostListener('focus')
  onFocus() {
    if (this.logAmplitudeTrigger === 'focus') {
      this._log();
    }
  }

  private _log() {
    this._amplitude.logEvent(this.logAmplitudeEvent, this.logAmplitudeProps);
  }
}
